import { Routes } from '@angular/router';
import * as components from './components'
import * as resolvers from "./resolver";
import { BoxOfficeResolver } from "./components/box-office/box-office.resolver";
/*
import { MerchantRoutingModule } from './components/merchants/merchant-routing.module';
import { CustomerModule } from './components/customer-management/customer.module'
import { OpenItemsModule } from './components/open-items/open-items.module'
import { VenueModule } from './components/venue-components/venue.module'
import { OrderModule } from './components/order-components/order.module'
import { CheckoutModule } from './components/checkout-components/checkout.module'
import { SeatingplanModule } from './components/seatingplan-components/seatingplan.module'
import { SeatingplanSaleModule } from './components/seatingplan-sale/seatingplan-sale.module';
import { PrinterModule } from './components/printer/printer.module';

function seatingplansale() {
	return SeatingplanSaleModule;
}
function merchantRouting() {
	return MerchantRoutingModule
}
function customer() {
	return CustomerModule
}
function venue() {
	return VenueModule
}
function order() {
	return OrderModule
}
function checkout() {
	return CheckoutModule
}
function seatingplan() {
	return SeatingplanModule
}
function openItems() {
	return OpenItemsModule
}
function printer() {
	return PrinterModule
}*/
export const ROUTES: Routes = [
	{ path: '', redirectTo: 'sale', pathMatch: 'full' },
	{ path: 'events/new', component: components.EventFormComponent, resolve: { event: resolvers.EventFormResolver }},
	{ path: 'events/:id', component: components.EventFormComponent, resolve: { event: resolvers.EventFormResolver }},
	{ path: 'events', component: components.EventListComponent, resolve: { eventOverview: resolvers.EventListResolver } },
	{ path: 'sale', component: components.EventsOnSaleComponent, resolve: { eventsOnSale: resolvers.EventsOnSaleResolver } },
	{ path: 'sale/:id', component: components.EventTickets, resolve: { event: resolvers.EventTicketsResolver } },
	{ path: 'box-office',
		component: components.EventsOnSaleComponent,
		resolve: { eventsOnSale: resolvers.EventsOnSaleResolver },
		data: {boxOffice: 'true'}
	},
	{ path: 'box-office/:id',
		component: components.BoxOffice,
		resolve: { BoxOfficeResolver }
	},
	{ path: 'box-office-seatingplan/:id',
		component: components.BoxOffice,
		resolve: { BoxOfficeResolver },
		data: {boxOfficeSP: 'true'}
	},
	{ path: 'seatingplanSale', loadChildren: 'app/components/seatingplan-sale/seatingplan-sale.module#SeatingplanSaleModule'},
	{ path: 'seatingplan-sale-box-office',
		loadChildren: 'app/components/seatingplan-sale/seatingplan-sale.module#SeatingplanSaleModule',
		data: {boxOfficeSP: 'true'}},
	{ path: 'merchants', loadChildren: 'app/components/merchants/merchant-routing.module#MerchantRoutingModule' },
	{ path: 'customers', loadChildren: 'app/components/customer-management/customer.module#CustomerModule'},
	{ path: 'venues', loadChildren: 'app/components/venue-components/venue.module#VenueModule' },
	{ path: 'orders', loadChildren: 'app/components/order-components/order.module#OrderModule'},
	{ path: 'checkout', loadChildren:  'app/components/checkout-components/checkout.module#CheckoutModule'},
	{ path: 'seatingplans', loadChildren: 'app/components/seatingplan-components/seatingplan.module#SeatingplanModule'},
	{ path: 'open-items', loadChildren: 'app/components/open-items/open-items.module#OpenItemsModule'},
	{ path: 'printers', loadChildren: 'app/components/printer/printer.module#PrinterModule' },
	{ path: 'shoppingCarts', loadChildren: 'app/components/shoppingCarts/shoppingCarts.module#ShoppingCartsModule'},

	{ path: 'sponsors', loadChildren: 'app/components/sponsors/sponsor-routing.module#SponsorRoutingModule' },

	{ path: 'support', loadChildren: 'app/components/support/support-routing.module#SupportRoutingModule'},
]



// WEBPACK FOOTER //
// ./src/app/app.routes.ts